import {
  APP_INITIALIZED
} from 'utils/constants'

export default (state = {}, action) => {
  switch (action.type) {
    case APP_INITIALIZED:
      const { api } = action.data;
      return { api };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/app.js